import { render, staticRenderFns } from "./AddTruewalletModal.vue?vue&type=template&id=ea0a9af6&"
import script from "./AddTruewalletModal.vue?vue&type=script&lang=js&"
export * from "./AddTruewalletModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports